/**
 * Personalisation de la "palette" de bpmn-js : les icones principales
 */
export default class CustomPalette {
  constructor(create, elementFactory, palette, translate) {
    this.create = create;
    this.elementFactory = elementFactory;
    this.translate = translate;

    palette.registerProvider(this);
  }

  getPaletteEntries(element) {

    const {
      create,
      elementFactory,
      translate
    } = this;

    function createSendTask(event) {
      const shape = elementFactory.createShape({ type: 'bpmn:SendTask' });
      create.start(event, shape);
    }

    function createUserTask(event) {
      const shape = elementFactory.createShape({ type: 'bpmn:UserTask' });
      create.start(event, shape);
    }

    function createServiceTask(event) {
      const shape = elementFactory.createShape({ type: 'bpmn:ServiceTask' });
      create.start(event, shape);
    }

    return (entries) => {

      entries['create.send-task'] = {
        group: 'activity',
        className: 'bpmn-icon-send-task',
        title: translate('Create send task'),
        action: {
          dragstart: createSendTask,
          click: createSendTask
        }
      }

      entries['create.user-task'] = {
        group: 'activity',
        className: 'bpmn-icon-user-task',
        title: translate('Create user task'),
        action: {
          dragstart: createUserTask,
          click: createUserTask
        }
      }

      entries['create.service-task'] = {
        group: 'activity',
        className: 'bpmn-icon-service-task',
        title: translate('Create service task'),
        action: {
          dragstart: createServiceTask,
          click: createServiceTask
        }
      }

      delete entries['create.intermediate-event'];
      delete entries['create.data-object'];
      delete entries['create.data-store'];
      delete entries['create.subprocess-expanded'];
      delete entries['create.participant-expanded'];

      return entries;
    }
  }
}

CustomPalette.$inject = [
  'create',
  'elementFactory',
  'palette',
  'translate'
];